/*
 * @Author: Roman
 * @Date: 2023-06-07 15:25:23
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-08-18 15:19:00
 * @FilePath: \qpmn-site\src\environments\app-config.ts
 * @Description: 
 */


/**
 * 应用相关变量，不要再增加此配置文件配置项，以后配置项都放到envConfig中
 */
const appConfig = {
    // 网站code
    websiteCode: process.env.APP_WEBSITE_CODE!,
    builderDefaultTheme: process.env.BUILDER_DEFAULT_THEME!,
    // 用于标识缓存所属应用
    appName: process.env.APP_STORAGE_CODE!,
    // 默认语言
    DEFAULT_LANGUAGE: process.env.APP_LANGUAGE!,
    // 支持的语言
    SUPPORT_LANGUAGE: ["en", "zh_CN"],
}

export { appConfig }